import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../GlobalContext';

const ListAnggota = () => { 
  const navigate = useNavigate();
  const { api } = useGlobalContext();

  const [formData, setFormData] = useState(
    {simppokok:0, simpwajib:0, simphariraya:0, simpvbelanja:0}
  )

  useEffect(() => {
    getSetup();
  }, [])

  const getSetup = async () => {
    try {
      const response = await api.get('/api/setup/simpanan');
      const setupData = response.data.simpanan[0];
      setFormData({
        simppokok: setupData.spokok,
        simpwajib: setupData.swajib,
        simphariraya: setupData.shariraya,
        simpvbelanja: setupData.svbelanja
      });
    } catch (error) {
      console.error('Error fetching data:', error);      
    }
  };


  const handleEditChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^\d]/g, '');

    const formattedValue = new Intl.NumberFormat().format(numericValue);

    setFormData({...formData, [name] :formattedValue});
  };

  const updatedata = async () => {
    try {
      const vsimpananpokok =  String(formData.simppokok).replace(/[.,]/g, '');
      const vsimpwajib = String(formData.simpwajib).replace(/[.,]/g, '');
      const vsimphariraya = String(formData.simphariraya).replace(/[.,]/g, '');
      const vsimpvbelanja =  String(formData.simpvbelanja).replace(/[.,]/g, '');
      const updatedFormData = {
        spokok : vsimpananpokok,
        swajib : vsimpwajib,
        shariraya : vsimphariraya,
        svbelanja : vsimpvbelanja
      };      
      const response = await api.patch('/api/setup/simpanan', updatedFormData);
      navigate('/');
    } catch (error) {
      console.error('Error submitting data:', error);
    }
  }

  return (
    <div  style={{display: "flex",justifyContent: "center",alignItems: "center" }}> 
      <div className="row">
        <div className="col-14">
          <div className="card card-info">
            <div className="card-header">
              <h3 className="card-title">Setup Simpanan</h3>
            </div>
            <div className="card-body">
              <div className="form-group row">
                <label htmlFor="simppokok" className="col-sm-6 col-form-label">Simp. Pokok</label>
                <div className="col-sm-6">
                  <input type="text" className="form-control" id="simppokok" name="simppokok" value={formData.simppokok ? formData.simppokok.toLocaleString() : '0'} style={{ textAlign: 'right' }} onChange={handleEditChange}/>
                </div>
              </div>
              <div className="form-group row">
                <label htmlFor="simpwajib" className="col-sm-6 col-form-label">Simp. Wajib</label>
                <div className="col-sm-6">
                  <input type="text" className="form-control" id="simpwajib" name="simpwajib" value={formData.simpwajib ? formData.simpwajib.toLocaleString() : '0'} style={{ textAlign: 'right' }} onChange={handleEditChange}/>
                </div>
              </div>  
              <div className="form-group row">
                <label htmlFor="simphariraya" className="col-sm-6 col-form-label">Simp. Hari Raya</label>
                <div className="col-sm-6">
                  <input type="text" className="form-control" id="simphariraya" name="simphariraya" value={formData.simphariraya ? formData.simphariraya.toLocaleString() : '0'} style={{ textAlign: 'right' }} onChange={handleEditChange}/>
                </div>
              </div>  
              <div className="form-group row">
                <label htmlFor="simpvoucher" className="col-sm-6 col-form-label">Simp. Voucher</label>
                <div className="col-sm-6">
                  <input type="text" className="form-control" id="simpvbelanja" name="simpvbelanja" value={formData.simpvbelanja ? formData.simpvbelanja.toLocaleString() : '0'} style={{ textAlign: 'right' }} onChange={handleEditChange}/>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => navigate('/')}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={() => updatedata()}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>    
    </div>
  )
}  

export default ListAnggota;